import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconWand12 from './IconWand12';
import IconWand16 from './IconWand16';
import IconWand20 from './IconWand20';
import IconWand24 from './IconWand24';
import IconWand32 from './IconWand32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconWand = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconWand12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconWand16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconWand20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconWand24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconWand32 {...props} />}
        </span>
    );
};
IconWand.displayName = 'FondueIconWand';

export default memo(IconWand);
